<script setup lang="ts"></script>

<template>
  <div class="relative py-3 px-6 text-white bg-primary-700 rounded-b-3xl">
    <!-- overlay -->
    <div class="absolute inset-0 bg-cover bg-[url('/assets/header.png')] bg-no-repeat rounded-b-3xl"></div>
    <div class="container mx-auto flex items-center relative z-10 justify-center gap-6">
      <div>
        <h2 class="lg:text-xl font-bold">
          Free Professional School Website!
        </h2>
        <p class="lg:text-sm text-xs lg:block hidden">
          Boost your school's visibility with a modern website. Sign up and take advantage of this offer!
        </p>
      </div>
      <a
        href="https://api.whatsapp.com/send?phone=6282140880500&text=Halo%2C%20Gradin,%0aSaya%20ingin%20menanyakan%20website%20gratis%20untuk%20sekolah..."
        target="_blank"
        rel="noopener noreferrer"
        class="btn-cta">
        GET IT NOW
      </a>
    </div>
  </div>
</template>

<style scoped>
@reference "@/assets/styles/main.css";

.btn-cta {
  @apply text-white hover:text-primary-700;
  @apply border border-white;
  @apply hover:bg-gray-100;
  @apply lg:text-sm text-xs font-medium;
  @apply px-4 rounded-lg py-2.5;
  @apply transition;
}
</style>
